module.exports = __webpack_public_path__ + "components/flag/static/square/cd-8444f44a237d1ce4b0efb72cae680400.svg";